<h1 mat-dialog-title>Selected EFT</h1>
<div mat-dialog-content>
    <embed [src]="getResource()" width="500" height="600" type="application/pdf" />
    <br/>
</div>
<div mat-dialog-actions>
    <button mat-button class="closebtn" mat-button (click)="onCloseClick()">Close</button>
    <label>Note: Resource may not render if the file is too large.</label>
</div>